import { FEATURE_FLAGS } from '@/utils/feature-toggle-service';

export enum FeatureType {
	Tool = 'tool',
	Subflow = 'sub',
	AddOn = 'add-on',
	Portal = 'portal',
	Automation = 'automation',
	CommandBar = 'command-bar',
	ApiEndPoint = 'api-end-point',
	InternalNotification = 'internal-notification',
	CustomerNotification = 'customer-notification',
}

export const FEATURES_TYPES_ITEMS = [
	{
		id: 'internal',
		title: 'Team feature',
		itemsBackgroundColor: '#f1f7ff',
		description: 'For you and your team',
		bottomSectionBackgroundColor: '#F9FDFF',
		items: [
			{
				title: 'Add-ons',
				type: FeatureType.AddOn,
				mainIcon: 'creation-wizard-add-on-main',
				secondaryIcon: 'creation-wizard-add-on-secondary',
				mainDescription: 'Features added <b>into</b> the apps you use',
				descriptionsList: ['Create a button inside your app', 'Add a custom interface', 'Use contextual data from the item you’re on'],
			},
			{
				title: 'Tool',
				type: FeatureType.Tool,
				mainIcon: 'creation-wizard-tool-main',
				secondaryIcon: 'creation-wizard-tool-secondary',
				mainDescription: 'Features that work <b>anywhere.</b>',
				descriptionsList: ['Launch from the command bar with a shortcut', 'Add to Ply’s home menu', 'Create a standalone URL'],
			},
			{
				title: 'Internal notification',
				type: FeatureType.InternalNotification,
				mainIcon: 'creation-wizard-internal-notification-main',
				secondaryIcon: 'creation-wizard-internal-notification-secondary',
				mainDescription: 'Features that send <b>actionable</b> notifications',
				descriptionsList: ['Triggered by an event or on a schedule', 'Notify in the browser, email, or Slack'],
				// featureFlag: FEATURE_FLAGS.NOTIFICATIONS_ENABLED,
			},
		],
	},
	{
		id: 'external',
		title: 'Customer feature',
		itemsBackgroundColor: '#F2EDF7',
		description: 'For your customers',
		bottomSectionBackgroundColor: '#FBFAFD',
		items: [
			{
				title: 'Portal',
				type: FeatureType.Portal,
				mainIcon: 'creation-wizard-portal-main',
				secondaryIcon: 'creation-wizard-portal-secondary',
				mainDescription: '<b>Standalone</b> or <b>embeddable</b> features',
				descriptionsList: ['Works from mobile and desktop', 'Personalized with data from URL parameters', 'Customizable look and feel'],
				featureFlag: FEATURE_FLAGS.PORTAL_CREATION_ENABLED,
			},
			{
				disabled: true,
				title: 'Customer notification',
				type: FeatureType.CustomerNotification,
				mainIcon: 'creation-wizard-customer-notification-main',
				secondaryIcon: 'creation-wizard-customer-notification-secondary',
				mainDescription: 'Features that send <b>actionable</b> notifications',
				descriptionsList: ['Triggered by an event or on a schedule', 'Sent over email'],
			},
		],
	},
	{
		id: 'automatic',
		title: 'Automation',
		itemsBackgroundColor: '#F7F8FA',
		description: 'Runs in the background',
		bottomSectionBackgroundColor: '#F7F8FA',
		items: [
			{
				title: 'Automation',
				type: FeatureType.Automation,
				mainIcon: 'creation-wizard-automation-main',
				featureFlag: FEATURE_FLAGS.SHOW_CLOUD_FLOWS_CREATION,
				secondaryIcon: 'creation-wizard-automation-secondary',
				mainDescription: 'Features that run <b>automatically</b>',
				descriptionsList: ['Triggered by an event or on a schedule', 'No user-facing steps'],
			},
			{
				title: 'API end-point',
				type: FeatureType.ApiEndPoint,
				mainIcon: 'creation-wizard-api-end-point-main',
				disabled: true,
				secondaryIcon: 'creation-wizard-api-end-point-secondary',
				mainDescription: '<b>Callable</b> features that <b>return values</b>',
				descriptionsList: ['Can be used as steps in other features', 'Accessible inside your workspace or publicly'],
			},
		],
		showOnlyIfHasAvailableItems: true,
	},
];
